import React from "react";
import LeafletMap from "../shared/components/LeafletMap";
import APIClient from "./client";
import Legend from "./components/Legend";
import "./stylesheets/cloudfarm-r.scss";
import moment from "moment";

import cropr from "../shared/utils/cropr";

import DatasetListItem from "./components/DatasetListItem";

class CloudfarmLight extends React.Component {
  state = {
    selectedMeasurementLayers: [],
  };

  componentDidMount() {
    if (cropr && cropr.l10n) moment.locale(cropr.l10n.languageCode);
    cropr.setDataset = (ds) => {
      this.setState({
        dataset: ds,
        selectedMeasurementLayers: [],
      });
    };
  }

  toggleMeasurementLayer = (ds, measurement, layer) => {
    let dsUuid = ds.uuid,
      measurementId = measurement.id,
      layerId = layer ? layer.id : "";
    let selectedMeasurementLayers = this.state.selectedMeasurementLayers.slice();
    // debugger
    let measurementLayer = selectedMeasurementLayers.find(
      (sml) =>
        sml.dsUuid === dsUuid && sml.measurementId === measurementId && sml.layerId === layerId
    );
    if (measurementLayer) {
      selectedMeasurementLayers.splice(selectedMeasurementLayers.indexOf(measurementLayer), 1);
    } else {
      measurementLayer = {
        dsUuid: dsUuid,
        measurementId: measurementId,
        layerId: layerId,
        ds: ds,
        measurement: measurement,
        layer: layer,
      };
      selectedMeasurementLayers.push(measurementLayer);
      this.loadMeasurementLayer(measurementLayer);
    }
    this.setState({ selectedMeasurementLayers: selectedMeasurementLayers });
  };

  updateMeasurementLayer = (measurementLayer, data, opacity) => {
    const selectedMeasurementLayers = this.state.selectedMeasurementLayers.slice();
    const selectedMeasurementLayer = selectedMeasurementLayers.find(
      (sml) =>
        sml.dsUuid === measurementLayer.dsUuid &&
        sml.measurementId === measurementLayer.measurementId &&
        sml.layerId === measurementLayer.layerId
    );
    if (selectedMeasurementLayer) {
      if (data) {
        selectedMeasurementLayer.data = data;
      }
      if (opacity) {
        selectedMeasurementLayer.opacity = opacity;
      }
      this.setState({ selectedMeasurementLayers: selectedMeasurementLayers });
    }
  };
  reloadMeasurementLayer = (measurementLayer, imageType, ignore0) => {
    this.loadMeasurementLayer(measurementLayer, imageType, ignore0);
  };

  async loadMeasurementLayer(measurementLayer, imageType, ignore0) {
    let path =
      "api/v3/cloud_farm/data/datasets/" +
      measurementLayer.dsUuid +
      "/measurements/" +
      measurementLayer.measurementId +
      (measurementLayer.layerId ? "/layers/" + measurementLayer.layerId + "/" : "/");
    let payLoad = {
      ignore_0: !!ignore0,
      cloudfarm_domain: "/",
      farmcontactdid: cropr.farmcontactdid,
    };
    if (imageType) {
      payLoad.imageType = imageType;
    }
    let data = await APIClient.get(path, payLoad);
    this.updateMeasurementLayer(measurementLayer, data);
  }

  render() {
    return (
      <div className={"full-height container-fluid pl-0 pr-0"}>
        <div className="row no-gutters full-height">
          <div className="col-4 full-height">
            <div id="stream" className="stream-has-options full-height">
              <div id="stream-wrapper" className="pb-2 pt-3">
                {this.state.dataset ? (
                  <DatasetListItem
                    uuid={this.state.dataset.uuid}
                    toggleMeasurementLayer={this.toggleMeasurementLayer}
                    selectedMeasurementLayers={this.state.selectedMeasurementLayers}
                    dataset={this.state.dataset}
                    expanded={true}
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-8 full-height">
            {this.state.dataset ? (
              <LeafletMap
                locations={this.state.selectedMeasurementLayers
                  .filter((sml) => sml.data)
                  .map((sml) => ({
                    type: "image",
                    url: sml.data.url,
                    bounds: sml.data.bounding_box,
                    zoomTo: true,
                    opacity: sml.opacity || 1,
                    measurementLayer: sml,
                    key: sml.dsUuid + sml.measurementId + sml.layerId,
                  }))}
                extraLayers={true}
                height={"calc(100vh - 180px)"}
              />
            ) : null}
          </div>
          <div id="cloudfarm_map_legends" style={{ zIndex: 500 }}>
            <ul className="legend-container">
              {this.state.selectedMeasurementLayers
                .filter((sml) => sml.data)
                .map((sml) => (
                  <Legend
                    key={sml.dsUuid + sml.measurementId + sml.layerId}
                    measurementLayer={sml}
                    toggleMeasurementLayer={this.toggleMeasurementLayer}
                    loadMeasurementLayer={this.reloadMeasurementLayer}
                    updateMeasurementLayer={this.updateMeasurementLayer}
                  />
                ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default CloudfarmLight;
